import React, { useState, useEffect, useContext, useMemo } from "react";

import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import DocTypesService from '../../services/docTypes.servicse';
import { Grid, Container } from '@material-ui/core';

import personsServicse from '../../services/persons.servicse';
import AirportsService from '../../services/airports.servicse';
import CountriesService from '../../services/countries.servicse';

import SelectCustom from '../FormsUI/Select';
import TextfieldEnLetters from '../FormsUI/TextfieldEnLetters';
import DatePickerFormsUI from '../FormsUI/DatePicker';
import TextfieldGeneral from '../FormsUI/TextfieldGeneral';
import TextfieldNumbers from '../FormsUI/TextfieldNumbers';
import AppSelectFormik from "components/formik/AppSelectFormik";
import { filterOptions, findOptionByValue } from "utils/common-utils";
import AppButton from 'components/FormsUI/AppButton/appButton';
//import AuthContext from "store/AuthContext";
import AppSpinner from "components/common/AppSpinner";
import ToastContext from "store/ToastContext";

import "../common/formStyle.css";

const MAX_OPTIONS = 50;

const PersonNewEditModal = (props) => {

    //const { userInfo } = useContext(AuthContext);
    const { openToast } = useContext(ToastContext);
    const [countriesOptions, setCountriesOptions] = useState([]);
    const [docTypesOptions, setDocTypesOptions] = useState([]);
    const [allAirports, setAllAirports] = useState([]);
    const [errMessage, setErrMessage] = useState("");
    const [spinnerLoading, setSpinnerLoading] = useState(true);
    const [isInitDone, setIsInitDone] = useState(false);
    const [isCrew, setIsCrew] = useState(false);
    const {person = {}, action = "Add", personType, flight, flight: { id: flightId } } = props;

    //const errors = {};

    useEffect(() => {
      const init = async () => {
        await AirportsService.getAirportsOptions().then(setAllAirports);
        await DocTypesService.getDocTypesOptions().then(setDocTypesOptions);
        await CountriesService.getCountriesOptions().then(setCountriesOptions);
        setSpinnerLoading(false);
        setIsInitDone(true);
      };

      setIsCrew(personType === "Crew");
      init();
    }, [personType]);

    let personId = "";
    if (props.person !== null) {
      personId = props.person.id;
      if (person.gender === "M") {
        person.gender = "MALE";
      }
      if (person.gender === "F") {
        person.gender = "FEMALE";
      }
    }

    const genderOptions = [
      { value: "MALE", label: "MALE" },
      { value: "FEMALE", label: "FEMALE" },
      { value: "UNKNOWN", label: "UNKNOWN" },
    ];

    const today = new Date();

    const airportsFilter = (inputVal) =>
      new Promise((res) =>
        res(filterOptions(inputVal, allAirports, MAX_OPTIONS))
      );

    const docTypesFilter = (inputVal) =>
      new Promise((res) =>
        res(filterOptions(inputVal, docTypesOptions, MAX_OPTIONS))
      );

    const countryFilter = (inputVal) =>
      new Promise((res) =>
        res(filterOptions(inputVal, countriesOptions, MAX_OPTIONS))
      );

    const airportsDefaultOptions = useMemo(
      () => filterOptions("", allAirports),
      [allAirports]
    );

    const docTypesDefaultOptions = useMemo(
      () => filterOptions("", docTypesOptions),
      [docTypesOptions]
    );

    const countriesDefaultOptions = useMemo(
      () => filterOptions("", countriesOptions),
      [countriesOptions]
    );

    

    const handleSubmit = async (inValues) => {
    
        setSpinnerLoading(true);

        const values = {...inValues, 
            embarkingAirport: inValues.embarkingAirport.value, 
            finalAirport: inValues.finalAirport.value,
            nationalityCountry: inValues.nationalityCountry.value,
            issuingCountry: inValues.issuingCountry.value,
            docTypeMrz: inValues.docTypeMrz.value
        }
        let isValid = true;
        setErrMessage("");
        values.expiryDate = new Date(values.expiryDate);

        if (values.embarkingAirport && values.finalAirport) {

            if (values.embarkingAirport === flight.arrivalAirport) {
                isValid = false;
                setErrMessage("Embarking Airport and the flight’s Arrival Airport Are identical. Please select another Embarking Airport");
            }

            if (values.finalAirport === flight.departureAirport) {
                isValid = false;
                setErrMessage("Final Airport and the flight’s Departure Airport Are identical. Please select another Final Airport");
            }

            if (values.finalAirport === values.embarkingAirport) {
                isValid = false;
                setErrMessage("Departure Airport and Arrival Airport Are identical. Please select another Departure/Arrival airport");
            }
        }

        if (values.personalId !== undefined && values.personalId !== "") {
            if (values.nationalityCountry !== "ISR" && values.nationalityCountry !== "PS"
                && values.nationalityCountry !== "PSE") {
                isValid = false;
                setErrMessage("PersonalId is not valid for this nationality");
            }
            if (values.nationalityCountry === "ISR" || values.nationalityCountry === "PS"
                || values.nationalityCountry === "PSE") {
                if (values.personalId.length < 2 || values.personalId.length > 9) {
                    isValid = false;
                    setErrMessage("Personal Id can contain 2 to 9 digits");
                }
            }
        }

        if (values.expiryDate===undefined){values.expiryDate=null;}
        if (values.expiryDate!==null) {
          if (values.expiryDate < today){
            isValid = false;            
              setErrMessage("Please note that Expiry Date has passed, correct if wrong");
          }
        }

        if (!isValid) {
            setSpinnerLoading(false);
        } else if (isValid) {
            values.flightId = flightId;

            var isPersonExsist = await personsServicse.FindPassengerCrew(values);
            var member=personType === "Crew" ? "Crew member" : "Passenger";
            if (action === "Update") {
                if (isPersonExsist.responseCode !== 0 && isPersonExsist.personId !== values.id) {
                    isValid = false;
                    setErrMessage("Another passenger/crew member already exists with this travel document and issuing country");
                    setSpinnerLoading(false);
                    return;
                }
                else {
                    setErrMessage("");
                }
                values.passengerCrew = personType;
                values.personId = personId;
                values.id = props.person.id;
                var updatePerson = await personsServicse.UpdatePerson(values);
                if (updatePerson.code === 0) {
                    openToast(member+" updated", "success")
                    props.onSubmitted(values, "update");
                } else {
                    openToast("Error occurred, "+member+" not updated.", "error", {duration: 8000})
                    setSpinnerLoading(false);
                }
            } else {
                if (isPersonExsist.responseCode !== 0) {
                    isValid = false;
                    setErrMessage("Another person with this PNR and Unique Id already exists");
                    setSpinnerLoading(false);
                    return;
                }
                else {
                    setErrMessage("");
                }
                values.FlightId = flightId;
                values.PassengerCrew = personType === "Crew" ? "FM" : "FL";
                values.birthDate = new Date(values.birthDate);
                const addPerson = await personsServicse.AddPerson(values);
                if (addPerson.code === 0) {
                    openToast(member+" added", "success")
                    props.onSubmitted(0, "new");
                } else {
                    openToast("Error occurred, "+member+" not added.", "error", {duration: 8000})
                }
                setSpinnerLoading(false);
            }
        }
    }

    const formInitialValues =  {
            id: person.id ? person.id : '',
            seatNumber: person.seatNumber ? person.seatNumber : '',
            expiryDate: person.expiryDate ? person.expiryDate.split('T')[0] : '',
            pnr: person.pnr ? person.pnr : '',
            uniqueId: person.uniqueId ? person.uniqueId : '',
            lastName: person.lastName ? person.lastName : '',
            firstName: person.firstName ? person.firstName : '',
            gender: person.gender !== undefined ? person.gender.toUpperCase() : '',
            birthDate: person.birthDate ? person.birthDate.split('T')[0] : '',
            docTypeMrz:  (person.docTypeMrz  ===undefined || person.docTypeMrz ===null ) ? null:findOptionByValue(person.docTypeMrz, docTypesOptions) ,
            travelDocumentNumber: person.travelDocumentNumber ? person.travelDocumentNumber : '', 
            //ExpiryDate: '',
            personalId: person.personalId ? person.personalId : '',
            embarkingAirport: (person.embarkingAirport  ===undefined || person.embarkingAirport ===null ) ?null: findOptionByValue(person.embarkingAirport, allAirports) ,
            finalAirport: (person.finalAirport  ===undefined || person.finalAirport ===null ) ?null: findOptionByValue(person.finalAirport, allAirports) ,
            issuingCountry: (person.issuingCountry  ===undefined || person.issuingCountry ===null ) ?null: findOptionByValue(person.issuingCountry, countriesOptions) ,
            nationalityCountry: (person.nationalityCountry  ===undefined || person.nationalityCountry ===null ) ?null: findOptionByValue(person.nationalityCountry, countriesOptions) ,
            status: person.status !== undefined ? person.status : '',
            stage: person.stage !== undefined ? person.stage : '',
            personType: isCrew
     }

    const formValidationSchema = Yup.object().shape({
        pnr: Yup.string().
            when("personType", {is: false, then: Yup.string().required('Required *')}),
        lastName: Yup.string().required('Required *').
            matches(/^[a-zA-Z- ]+$/, "Invalid input format"),
        firstName: Yup.string().required('Required *').
            matches(/^[a-zA-Z- ]+$/, "Invalid input format"),
        gender: Yup.string().required('Required *'),
        birthDate: Yup.date().required('Required *').
            test('len', 'Year must be exactly 4 characters',
                val => val && val.getFullYear().toString().length === 4).
            max(today, 'Cannot be a future date'),
        docTypeMrz: Yup.object().shape({value: Yup.string().required()}).nullable().required('Required *'),
        travelDocumentNumber: Yup.string().
            required('Required *').
            min(5, 'Min 5 letters and digits').
            max(9, 'Max 9 letters and digits'),        
        expiryDate: Yup.date().notRequired().test('expiryDate', 'Expiry Date has passed', function(value) {        
          if (value!==undefined) {
            const schema =Yup.date().min(new Date(), "Expiry Date has passed")          
            return schema.isValidSync(value);
          }
          return true;
        }),            
        issuingCountry: Yup.object().shape({value: Yup.string().required()}).nullable().required('Required *'),
        nationalityCountry: Yup.object().shape({value: Yup.string().required()}).nullable().required('Required *'),
        embarkingAirport: Yup.object().shape({value: Yup.string().required()}).nullable().required('Required *'),
        finalAirport: Yup.object().shape({value: Yup.string().required()}).nullable().required('Required *'),
        personType: Yup.bool()
    })
    return (
       isInitDone ? 
        <Grid container> 
          <Grid item xs={12}>
            <Container maxWidth="md">
              <div>
                <Formik
                  initialValues={formInitialValues}
                  validationSchema={formValidationSchema}
                  onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    handleSubmit(values);
                  }}>
                  {(props) => {
                    const { values, handleSubmit } = props;
                    return (
                      <Form onSubmit={handleSubmit} noValidate>
                        <input name="id" id="id" type="hidden" value={values?.id} />
                        <input name="PersonId" id="PersonId" type="hidden" value={values?.personId} />
                        <input name="Status" id="Status" type="hidden" value={values?.status} />
                        <input name="Stage" id="Stage" type="hidden" value={values?.stage} />
                        <Grid container spacing={2}>
                          {personType !== "Crew" && (
                            <>
                              <Grid item xs={6}>
                                {action === "Update" ? (
                                  <label>PNR: {values?.pnr}</label>
                                ) : (
                                  <TextfieldGeneral
                                    name="pnr"
                                    label="PNR"
                                    size="small"></TextfieldGeneral>
                                )}
                              </Grid>
                              <Grid item xs={6}>
                                {action === "Update" ? (
                                  <label>Unique Id: {values?.uniqueId}</label>
                                ) : (
                                  <TextfieldGeneral
                                    name="uniqueId"
                                    label="Unique Id"
                                    size="small"></TextfieldGeneral>
                                )}
                              </Grid>
                            </>
                          )}
                          <Grid item xs={6}>
                            <TextfieldEnLetters
                              name="lastName"
                              label="Last Name"
                              size="small"></TextfieldEnLetters>
                          </Grid>
                          <Grid item xs={6}>
                            <TextfieldEnLetters
                              name="firstName"
                              label="First Name"
                              size="small"></TextfieldEnLetters>
                          </Grid>
                          <Grid item xs={6}>
                            <SelectCustom
                              name="gender"
                              label="Gender"
                              options={genderOptions}
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextfieldGeneral
                              name="seatNumber"
                              label="Seat Number"
                              size="small"></TextfieldGeneral>
                          </Grid>
                          <Grid item xs={6} className="pb-0">
                            <DatePickerFormsUI
                              name="birthDate"
                              label="Birth date"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={6} className="pb-0">
                            <DatePickerFormsUI
                              name="expiryDate"
                              label="Expiry Date"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={6} className="py-0">
                            <AppSelectFormik
                              defaultOptions={docTypesDefaultOptions}
                              name="docTypeMrz"
                              placeholder="Document type"
                              isClearable={true}
                              loadOptions={docTypesFilter}
                              label="Travel document type"
                              {...props}
                            />
                          </Grid>
                          <Grid item xs={6} style={{paddingTop: 28, paddingBottom: 0}}>
                            <TextfieldGeneral
                              name="travelDocumentNumber"
                              label="Travel Document"
                              size="small"></TextfieldGeneral>
                          </Grid>
                          <Grid item xs={6}  className="py-0">
                            <AppSelectFormik
                              defaultOptions={airportsDefaultOptions}
                              name="embarkingAirport"
                              placeholder="Embarking Airport"
                              isClearable={true}
                              loadOptions={airportsFilter}
                              label="Embarking Airport"
                              {...props}
                            />
                          </Grid>
                          <Grid item xs={6} className="py-0">
                            <AppSelectFormik
                              defaultOptions={airportsDefaultOptions}
                              name="finalAirport"
                              placeholder="Final Airport"
                              isClearable={true}
                              loadOptions={airportsFilter}
                              label="Final Airport"
                              {...props}
                            />
                          </Grid>
                          <Grid item xs={6} className="pt-0">
                            <AppSelectFormik
                              defaultOptions={countriesDefaultOptions}
                              name="issuingCountry"
                              placeholder="Issuing country"
                              isClearable={true}
                              loadOptions={countryFilter}
                              label="Issuing country"
                              {...props}
                            />
                          </Grid>
                          <Grid item xs={6} className="pt-0">
                            <AppSelectFormik
                              defaultOptions={countriesDefaultOptions}
                              name="nationalityCountry"
                              placeholder="Nationality country"
                              isClearable={true}
                              loadOptions={countryFilter}
                              label="Nationality country"
                              {...props}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextfieldNumbers
                              name="personalId"
                              label="Personal ID"
                              size="small"></TextfieldNumbers>
                          </Grid>
                          {errMessage && (
                            <Grid item xs={12}>
                                <div className="alert alert-danger">
                                  {errMessage}
                                </div>
                            </Grid>
                          )}
                          <Grid container className="mb-2 px-2">
                            <Grid item xs></Grid>
                            <Grid item xs={2}>
                              <AppButton id="personFormSubmitBtn" type="submit" isLoading={spinnerLoading} label="SUBMIT" 
                                isBlock={true}
                              ></AppButton>
                            </Grid>
                          </Grid>
                        </Grid>
                        </Form>
                        );
                      }}
                </Formik>
                </div>
                </Container>
              </Grid>
          </Grid> : 
              <Grid item xs={12}>
                <div
                  className="marginAtTop"
                  style={{ textAlign: "center" }}>
                  <AppSpinner/>
                </div>
             </Grid>
    );
}

export default PersonNewEditModal;
